import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = '/admin/system_setting'

export default {
  getLanguages(tenant_id, pagination = defaultPagination, filterQuery, sort = null) {
    let is_paginate = pagination && pagination > 0 ? 1 : 0;
    return Repository.get(`/landlord/tenant/${tenant_id}/setting/languages?is_paginate=${is_paginate}&paginate=${pagination}&${filterQuery}&${sort != null ? 'filter[sort]=' + sort : null}`)
  },
  fetchLanguage(tenant_id, id) {
    return Repository.get(`/landlord/tenant/${tenant_id}/setting/languages/${id}`)
  },
  updateLanguage(tenant_id, id, payload) {
    return Repository.put(`/landlord/tenant/${tenant_id}/setting/languages/${id}`, payload)
  },
  getDocumentTypes(pagination = defaultPagination, filterQuery, sort = null) {
    let is_paginate = pagination && pagination > 0 ? 1 : 0;
    return Repository.get(`${resource}/document-types?is_paginate=${is_paginate}&paginate=${pagination}&${filterQuery}&${sort != null ? 'filter[sort]=' + sort : null}`)
  },
  fetchDocumentType(id) {
    return Repository.get(`${resource}/document-types/${id}`)
  },
  getDocumentTypeTranslations(filterQuery) {
    return Repository.get(`${resource}/document-type-translations?${filterQuery}`)
  },
  fetchDocumentTypeTranslation(id) {
    return Repository.get(`${resource}/document-type-translations/${id}`)
  },
  updateDocumentTypeTranslation(id, payload) {
    return Repository.put(`${resource}/document-type-translations/${id}`, payload)
  },
}
